import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import stripeIcon from "../../assests/page/Stripe_icon-square.svg";
import creditCardIcon from "../../assests/page/credit-card-icon.svg";
import cryptoIcon from "../../assests/page/crypto-icons.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import debitCardIcon from "../../assests/page/debit-card.svg";
import sepaCardIcon from "../../assests/page/sepa-card.svg";
import gpayIcon from "../../assests/page/gpay-icon.svg";
import accountIcon from "../../assests/page/account-balance-icon.svg";
import europeFlag from "../../assests/page/europe_flag.svg";
import indiaFlag from "../../assests/page/Flag_of_India 1.svg";
import switzerlandFlag from "../../assests/page/switzerland_flag.svg";
import stockEchangeLogo from "../../assests/page/stock-exchange-icon.png";
import AddFunds from "./addFunds";
import React, { useState } from "react";
import { StripePaymentForm } from "./stripePayment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import LoadingPopup from "./loading";
import SelectBank from "./selectBank";
import { useNavigate } from "react-router-dom";
import Avatar from "react-avatar";
import { useGetSupportedCurrencies } from "../../hooks/currencies";
import { useTranslation } from "react-i18next";

const PaymentMethods = (props) => {
  const { t } = useTranslation();
  const [showPaymentPortal, setShowPaymentPortal] = useState(
    props.showPaymentPortal || false,
  );
  const [showBankProvider, setShowBankProvider] = useState(
    props.showBankProvider || false,
  );
  const [paymentType, setPaymentType] = useState(props.paymentType || "");
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState({
    countryName: "",
    officialName: "",
    flag: null,
    currencySymbol: "",
    currencyName: "",
    officialCurrencySymbol: "",
    isClicked: false,
    balance: 0.0,
    isCrypto: true,
    tokenAddress: "",
  });
  const [newSearchContent, setNewSearchContent] = useState(null);

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);

  const { getSupportedCurrenciesData, getSupportedCurrenciesLoading } =
    useGetSupportedCurrencies("add-funds-crypto");

  const navigate = useNavigate();

  const handleChooseCurrencyButtonDisplay = () => {
    const button = document.getElementById("choose-currency-popup-button");
    if (button && selectedCurrency.isClicked) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  return (
    <div
      style={
        props.mobileScreen
          ? {
              width: "100%",
            }
          : {}
      }
      className="add-funds-popup"
    >
      {!showAllCurrencies && (
        <div className="add-funds-content">
          <div className="add-funds-content-header">
            <div className="add-funds-content-header-text-container">
              {!showPaymentPortal && !showBankProvider && (
                <img
                  onClick={() => {
                    if (props.backClickPopup) {
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(props.backClickPopup);
                    } else {
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(
                        <AddFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds"
                        />,
                      );
                    }
                  }}
                  className="add-funds-popup-back-icon"
                  alt="Back Icon"
                  src={backIcon}
                />
              )}
              {!showPaymentPortal && showBankProvider && (
                <img
                  onClick={() => {
                    setShowBankProvider(false);
                  }}
                  className="add-funds-popup-back-icon"
                  alt="Back Icon"
                  src={backIcon}
                />
              )}
              {showPaymentPortal && (
                <img
                  onClick={() => {
                    if (props.mobileScreen) {
                      navigate("/add-funds-method");
                    } else {
                      setShowPaymentPortal(false);
                      setPaymentType("");
                    }
                  }}
                  className="add-funds-popup-back-icon"
                  alt="Back Icon"
                  src={backIcon}
                />
              )}

              {!showPaymentPortal && !showBankProvider && (
                <p className="add-funds-content-header-text">
                  Select Payment Method
                </p>
              )}

              {!showPaymentPortal &&
                showBankProvider &&
                !props.isCustodyProviders && (
                  <p className="add-funds-content-header-text">
                    Select Bank Account Region
                  </p>
                )}
              {!showPaymentPortal &&
                showBankProvider &&
                props.isCustodyProviders && (
                  <p className="add-funds-content-header-text">
                    Select Custody Provider
                  </p>
                )}
              {showPaymentPortal && paymentType === "bank" && (
                <p className="add-funds-content-header-text">Pay with Bank</p>
              )}
              {showPaymentPortal && paymentType === "card" && (
                <p className="add-funds-content-header-text">
                  Pay with Debit/Credit card
                </p>
              )}
            </div>
            <img
              onClick={() => {
                if (!props.mobileScreen) {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  if (props.setPopupContentPosition) {
                    props.setPopupContentPosition("center");
                  }
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                } else {
                  navigate("/payments");
                }
              }}
              className="add-funds-popup-close-icon"
              alt="Close Icon"
              src={popupCloseIcon}
            />
          </div>
          <div className="payments-popup-content-footer">
            {!showPaymentPortal && !showBankProvider && (
              <div className="payments-popup-content-footer-container">
                {props?.addFundsAction !== "add-funds-others" && (
                  <div
                    onClickCapture={() => {
                      setPaymentType("bank");
                    }}
                    onClick={async () => {
                      if (
                        props.linkedBankIds?.length === 1 &&
                        props.linkedBankIds[0]?.providerType === "moneyhub"
                      ) {
                        props.setPopupContent(
                          <LoadingPopup
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            action={
                              props.isWithdraw
                                ? "moneyhub-acounts-withdraw"
                                : "moneyhub-acounts"
                            }
                            isCustom={true}
                            customTextHeader="Searching..."
                            customTextFooter={`fetching all linked bank accounts`}
                            custodians={props.custodians}
                            selectedCurrency={props.selectedCurrency}
                            generalDataProps={props.generalDataProps}
                            paymentType={"bank"}
                            bankAccountId={props.linkedBankIds[0]?.id}
                            amountInPence={props.amountInPence}
                            amount={props.amount}
                            confirmationFunc={props.confirmationFunc}
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      } else if (
                        props.linkedBankIds?.length === 1 &&
                        props.linkedBankIds[0]?.providerType === "blink"
                      ) {
                        props.setPopupContentPosition("flex-end");
                        props.setPopupContent(
                          <SelectBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            bankList={props?.bankList}
                            generalDataProps={props.generalDataProps}
                            bankAccountId={props.linkedBankIds[0]?.id}
                            backClickPopup={
                              props?.backClickPopup || (
                                <AddFunds
                                  setShowPopup={props.setShowPopup}
                                  setPopupContent={props.setPopupContent}
                                  setPopupContentPosition={
                                    props.setPopupContentPosition
                                  }
                                  setFavouriteClicked={
                                    props.setFavouriteClicked
                                  }
                                  generalDataProps={props.generalDataProps}
                                  addFundsAction="add-funds"
                                />
                              )
                            }
                            amountInPence={props.amountInPence}
                            amount={props.amount}
                            selectedCurrency={props.selectedCurrency}
                            action={
                              props.isWithdraw
                                ? "pre-withdraw"
                                : "pre-add-funds"
                            }
                            confirmationFunc={props.confirmationFunc}
                          />,
                        );
                        props.setShowPopup(true);
                      } else if (props.linkedBankIds?.length === 2) {
                        setShowBankProvider(true);
                      }
                    }}
                    className="payments-popup-content-footer-main"
                  >
                    <div className="payments-popup-content">
                      <div className="payments-popup-content-icon">
                        <img src={accountIcon} alt="Payment Method Icon" />
                      </div>
                      <p className="payments-popup-content-text">
                        {props?.bankSelectText
                          ? props.bankSelectText
                          : "Pay with Bank"}
                      </p>
                    </div>
                  </div>
                )}

                <div
                  onClickCapture={() => {
                    setPaymentType("card");
                  }}
                  onClick={async () => {
                    if (props.isWithdraw) {
                      props.setPopupContent(
                        <LoadingPopup
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          action="card-accounts-withdraw"
                          isCustom={true}
                          customTextHeader="Searching..."
                          customTextFooter={`fetching all linked card accounts`}
                          custodians={props.custodians}
                          selectedCurrency={props.selectedCurrency}
                          amount={props.amount}
                          generalDataProps={props.generalDataProps}
                          paymentType={"card"}
                          confirmationFunc={props.confirmationFunc}
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    } else {
                      props.setPopupContent(
                        <LoadingPopup
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          action="card-payment"
                          isCustom={true}
                          customTextHeader="Initializing..."
                          customTextFooter={`Creating card payment gateway for ${props.selectedCurrency?.tokenName.replace(
                            "VC",
                            "",
                          )}`}
                          custodians={props.custodians}
                          selectedCurrency={props.selectedCurrency}
                          generalDataProps={props.generalDataProps}
                          paymentType={"card"}
                          isOthersPayment={props?.isOthersPayment}
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    }
                  }}
                  className="payments-popup-content-footer-main"
                >
                  <div className="payments-popup-content">
                    <div className="payments-popup-content-icon">
                      <img src={creditCardIcon} alt="Payment Method Icon" />
                    </div>
                    <p className="payments-popup-content-text">
                      {props?.bankSelectText
                        ? props.cardSelectText
                        : "Pay with Debit/Credit Card"}
                    </p>
                  </div>
                </div>

                {props.showCryptoPayment && (
                  <div
                    onClickCapture={() => {
                      setPaymentType("card");
                    }}
                    onClick={async () => {
                      setShowAllCurrencies(true);
                    }}
                    className="payments-popup-content-footer-main"
                  >
                    <div className="payments-popup-content">
                      <div
                        style={{ width: "55px" }}
                        className="payments-popup-content-icon"
                      >
                        <img src={cryptoIcon} alt="Payment Method Icon" />
                      </div>
                      <p className="payments-popup-content-text">
                        {props?.cryptoSelectedText
                          ? props.cryptoSelectedText
                          : "Pay with Crypto"}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}
            {!showPaymentPortal && showBankProvider && (
              <div className="payments-popup-content-footer-container">
                {props?.isCustodyProviders && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        if (props.bankList?.length > 0) {
                          props.setPopupContent(
                            <SelectBank
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              setFavouriteClicked={props.setFavouriteClicked}
                              bankList={props?.bankList}
                              generalDataProps={props.generalDataProps}
                              backClickPopup={
                                <PaymentMethods
                                  setShowPopup={props.setShowPopup}
                                  setPopupContent={props.setPopupContent}
                                  setPopupContentPosition={
                                    props.setPopupContentPosition
                                  }
                                  setFavouriteClicked={
                                    props.setFavouriteClicked
                                  }
                                  generalDataProps={props.generalDataProps}
                                  showPaymentPortal={false}
                                  showBankProvider={true}
                                  isCustodyProviders={true}
                                  bankList={props.bankList}
                                />
                              }
                              action="custody-select-bank"
                            />,
                          );
                          props.setPopupContentPosition("flex-end");
                          props.setShowPopup(true);
                        }
                      }}
                      className="payments-popup-content-footer-main"
                    >
                      <div className="payments-popup-content">
                        <div className="payments-popup-content-icon">
                          <img
                            src={switzerlandFlag}
                            alt="Payment Method Icon"
                          />
                        </div>
                        <p className="payments-popup-content-text">
                          Switzerland
                        </p>
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        props.setPopupContent(null);
                        props.setPopupContentPosition("center");
                        props.setShowPopup(false);
                        navigate(
                          `/investments/portfolio/create-secondary?pId=orbis`,
                        );
                      }}
                      className="payments-popup-content-footer-main"
                    >
                      <div className="payments-popup-content">
                        <div className="payments-popup-content-icon">
                          <img src={indiaFlag} alt="Payment Method Icon" />
                        </div>
                        <p className="payments-popup-content-text">India</p>
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        props.setPopupContent(null);
                        props.setPopupContentPosition("center");
                        props.setShowPopup(false);
                        navigate(
                          `/investments/portfolio/create-secondary?pId=iniciador`,
                        );
                      }}
                      className="payments-popup-content-footer-main"
                    >
                      <div className="payments-popup-content">
                        <div className="payments-popup-content-icon">
                          <img
                            src="https://flagpedia.net/data/flags/h80/br.webp"
                            alt="Payment Method Icon"
                          />
                        </div>
                        <p className="payments-popup-content-text">Brazil</p>
                      </div>
                    </div>
                  </React.Fragment>
                )}
                {!props?.isCustodyProviders && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        props.setPopupContent(
                          <LoadingPopup
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            action={
                              props.isWithdraw
                                ? "moneyhub-acounts-withdraw"
                                : "moneyhub-acounts"
                            }
                            isCustom={true}
                            customTextHeader="Searching..."
                            customTextFooter={`fetching all linked bank accounts`}
                            custodians={props.custodians}
                            selectedCurrency={props.selectedCurrency}
                            generalDataProps={props.generalDataProps}
                            paymentType={"bank"}
                            bankAccountId={
                              props.linkedBankIds?.find(
                                (bnk) => bnk?.providerType === "moneyhub",
                              )?.id
                            }
                            amountInPence={props.amountInPence}
                            amount={props.amount}
                            confirmationFunc={props.confirmationFunc}
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }}
                      className="payments-popup-content-footer-main"
                    >
                      <div className="payments-popup-content">
                        <div className="payments-popup-content-icon">
                          <img src={europeFlag} alt="Payment Method Icon" />
                        </div>
                        <p className="payments-popup-content-text">
                          European Banks / Non Swiss
                        </p>
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        props.setPopupContentPosition("flex-end");
                        props.setPopupContent(
                          <SelectBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            bankList={props?.bankList}
                            generalDataProps={props.generalDataProps}
                            bankAccountId={
                              props.linkedBankIds?.find(
                                (bnk) => bnk?.providerType === "blink",
                              )?.id
                            }
                            backClickPopup={
                              props?.backClickPopup || (
                                <AddFunds
                                  setShowPopup={props.setShowPopup}
                                  setPopupContent={props.setPopupContent}
                                  setPopupContentPosition={
                                    props.setPopupContentPosition
                                  }
                                  setFavouriteClicked={
                                    props.setFavouriteClicked
                                  }
                                  generalDataProps={props.generalDataProps}
                                  addFundsAction="add-funds"
                                />
                              )
                            }
                            amountInPence={props.amountInPence}
                            amount={props.amount}
                            selectedCurrency={props.selectedCurrency}
                            action={
                              props.isWithdraw
                                ? "pre-withdraw"
                                : "pre-add-funds"
                            }
                            confirmationFunc={props.confirmationFunc}
                          />,
                        );
                        props.setShowPopup(true);
                      }}
                      className="payments-popup-content-footer-main"
                    >
                      <div className="payments-popup-content">
                        <div className="payments-popup-content-icon">
                          <img
                            src={switzerlandFlag}
                            alt="Payment Method Icon"
                          />
                        </div>
                        <p className="payments-popup-content-text">
                          Switzerland / Swiss Banks
                        </p>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            )}
            {showPaymentPortal && paymentType === "card" && (
              <React.Fragment>
                <div className="p-p-payment-portal-footer">
                  <div className="p-p-payment-portal-amount-info">
                    <div className="p-p-payment-portal-amount-info-header">
                      <div className="p-p-payment-portal-header-text-container">
                        <p className="p-p-payment-portal-header-text">
                          Adding funds to your Wallet
                        </p>
                        <p className="p-p-payment-portal-header-text-footer">
                          {props.selectedCurrency?.symbol}{" "}
                          {props.selectedCurrency?.amount}
                        </p>
                      </div>
                      {/* <button className="p-p-payment-portal-header-button">
                    <p className="p-p-payment-portal-header-button-text">
                      Apple Pay
                    </p>
                  </button> */}
                    </div>
                    {/* <div className="p-p-payment-portal-amount-info-separator">
                    <div className="p-p-payment-portal-line"></div>
                    <p className="p-payment-portal-separator-text">
                      OR Pay With
                    </p>
                    <div className="p-p-payment-portal-line"></div>
                  </div> */}
                    {/* <div className="p-p-payment-portal-amount-info-footer">
                    <div
                      id="p-p-payment-portal-debit-card"
                      onClick={(e) => {
                        setPaymentMethodClicked(true);
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "p-p-payment-portal-amount-footer-main-active"
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "p-p-payment-portal-amount-footer-main";
                        }
                        const currentTag = document.getElementById(
                          "p-p-payment-portal-debit-card"
                        );
                        currentTag.className =
                          "p-p-payment-portal-amount-footer-main-active";
                      }}
                      className="p-p-payment-portal-amount-footer-main"
                    >
                      <img src={debitCardIcon} alt="Other Payments Icon" />
                      <p className="p-p-payment-portal-amount-footer-text">
                        Debit Card
                      </p>
                    </div>
                    <div
                      id="p-p-payment-portal-credit-card"
                      onClick={(e) => {
                        setPaymentMethodClicked(true);
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "p-p-payment-portal-amount-footer-main-active"
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "p-p-payment-portal-amount-footer-main";
                        }
                        const currentTag = document.getElementById(
                          "p-p-payment-portal-credit-card"
                        );
                        currentTag.className =
                          "p-p-payment-portal-amount-footer-main-active";
                      }}
                      className="p-p-payment-portal-amount-footer-main"
                    >
                      <img src={debitCardIcon} alt="Other Payments Icon" />
                      <p className="p-p-payment-portal-amount-footer-text">
                        Credit Card
                      </p>
                    </div>
                    <div
                      id="p-p-payment-portal-sepa-card"
                      onClick={(e) => {
                        setPaymentMethodClicked(true);
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "p-p-payment-portal-amount-footer-main-active"
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "p-p-payment-portal-amount-footer-main";
                        }
                        const currentTag = document.getElementById(
                          "p-p-payment-portal-sepa-card"
                        );
                        currentTag.className =
                          "p-p-payment-portal-amount-footer-main-active";
                      }}
                      className="p-p-payment-portal-amount-footer-main"
                    >
                      <img src={sepaCardIcon} alt="Other Payments Icon" />
                      <p className="p-p-payment-portal-amount-footer-text">
                        SEPA Card
                      </p>
                    </div>
                    <div
                      id="p-p-payment-portal-gpay"
                      onClick={(e) => {
                        setPaymentMethodClicked(true);
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "p-p-payment-portal-amount-footer-main-active"
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "p-p-payment-portal-amount-footer-main";
                        }
                        const currentTag = document.getElementById(
                          "p-p-payment-portal-gpay"
                        );
                        currentTag.className =
                          "p-p-payment-portal-amount-footer-main-active";
                      }}
                      className="p-p-payment-portal-amount-footer-main"
                    >
                      <img src={gpayIcon} alt="Other Payments Icon" />
                      <p className="p-p-payment-portal-amount-footer-text">
                        G Pay
                      </p>
                    </div>
                  </div> */}
                  </div>
                  <div className="p-p-payment-portal-contact-info">
                    <Elements
                      stripe={stripePromise}
                      options={{ clientSecret: props.paymentSecret }}
                    >
                      <StripePaymentForm
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        clientSecret={props.paymentSecret}
                        currencySymbol={props.selectedCurrency?.tokenName}
                        custodians={props.custodians}
                        selectedCurrency={props.selectedCurrency}
                        generalDataProps={props.generalDataProps}
                        custodianDetails={props.custodianDetails}
                        mobileScreen={props.mobileScreen}
                      />
                    </Elements>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      )}

      {showAllCurrencies && (
        <React.Fragment>
          <div
            style={{ overflow: "auto", marginBottom: "30px" }}
            className="add-funds-content"
          >
            <div className="add-funds-content-header">
              <div className="add-funds-content-header-text-container">
                <img
                  onClick={() => {
                    setShowAllCurrencies(false);
                    setNewSearchContent(null);
                  }}
                  className="add-funds-popup-back-icon"
                  alt="Back Icon"
                  src={backIcon}
                />
                <p className="add-funds-search-header-text">
                  Choose a Currency
                </p>
              </div>
              <img
                onClick={() => {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  setNewSearchContent(null);
                  props.setPopupContentPosition("center");
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                }}
                className="add-funds-popup-close-icon"
                alt="Close Icon"
                src={popupCloseIcon}
              />
            </div>
            <div className="add-funds-content-search">
              <img alt="Search Icon" src={searchIcon} />
              <input
                onInputCapture={() => {
                  selectedCurrency.isClicked = false;
                }}
                onInput={(e) => {
                  if (e.target.value === "") {
                    setNewSearchContent(null);
                  } else {
                    setNewSearchContent(
                      // eslint-disable-next-line array-callback-return
                      getSupportedCurrenciesData.filter((curr) => {
                        if (
                          curr.currencySymbol
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                        ) {
                          curr.searched = e.target.value.toLowerCase();
                          curr.nameArray = curr.currencySymbol.split("");
                          return curr;
                        }
                      }),
                    );
                  }
                  const previouslyActiveTag = document.getElementsByClassName(
                    "a-f-content-search-header-main-active",
                  );
                  if (previouslyActiveTag.length > 0) {
                    previouslyActiveTag[0].className =
                      "a-f-content-search-header-main";
                  }
                  handleChooseCurrencyButtonDisplay();
                }}
                className="add-funds-content-search-input"
                type="text"
                placeholder={t("placeholder.currencySearch")}
              />
            </div>

            <div className="add-funds-content-search-result">
              <div className="a-f-content-search-result-header">
                {getSupportedCurrenciesLoading && (
                  <p>{t("common.loading")}...</p>
                )}
                {!newSearchContent &&
                  getSupportedCurrenciesData
                    .filter(
                      (curr) =>
                        curr.currencySymbol &&
                        curr.officialCurrencySymbol &&
                        curr.currencyName,
                    )
                    .map((curr, idx) => (
                      <div
                        id={`crypto-curencies-${idx}`}
                        key={`crypto-curencies-${idx}`}
                        onClickCapture={() => {
                          curr["isClicked"] = true;
                          setSelectedCurrency(curr);
                        }}
                        onClick={(e) => {
                          const previouslyActiveTag =
                            document.getElementsByClassName(
                              "a-f-content-search-header-main-active",
                            );
                          if (previouslyActiveTag.length > 0) {
                            previouslyActiveTag[0].className =
                              "a-f-content-search-header-main";
                          }
                          const currentTag = document.getElementById(
                            `crypto-curencies-${idx}`,
                          );
                          currentTag.className =
                            "a-f-content-search-header-main-active";
                          handleChooseCurrencyButtonDisplay();
                        }}
                        className="a-f-content-search-header-main"
                      >
                        <div className="a-f-content-search-header-main-container">
                          <div className="a-f-content-search-header-main-content">
                            <div className="a-f-content-search-header-image">
                              <Avatar name={curr.currencySymbol} />
                            </div>
                            <div className="a-f-content-search-header-text-container">
                              <p className="a-f-content-search-header-text-header">
                                {curr.currencySymbol}
                              </p>
                              <p className="a-f-content-search-header-text-footer">
                                {curr.currencyName}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                {newSearchContent &&
                  newSearchContent.length > 0 &&
                  newSearchContent.map((curr, idx) => (
                    <div
                      id={`crypto-curencies-${idx}`}
                      key={`crypto-curencies-${idx}`}
                      onClickCapture={() => {
                        curr["isClicked"] = true;
                        setSelectedCurrency(curr);
                      }}
                      onClick={(e) => {
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "a-f-content-search-header-main-active",
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "a-f-content-search-header-main";
                        }
                        const currentTag = document.getElementById(
                          `crypto-curencies-${idx}`,
                        );
                        currentTag.className =
                          "a-f-content-search-header-main-active";
                        handleChooseCurrencyButtonDisplay();
                      }}
                      className="a-f-content-search-header-main"
                    >
                      <div className="a-f-content-search-header-main-container">
                        <div className="a-f-content-search-header-main-content">
                          <div className="a-f-content-search-header-image">
                            <Avatar name={curr.currencySymbol} />
                          </div>
                          <div className="a-f-content-search-header-text-container">
                            <p className="a-f-content-search-header-text-header">
                              {curr.nameArray?.length > 0 &&
                                curr.nameArray.map((nm, idx) => (
                                  <>
                                    {!curr.searched.includes(
                                      nm.toLowerCase(),
                                    ) && (
                                      <span
                                        key={idx}
                                        style={{
                                          color: "#B6B7C3",
                                        }}
                                      >
                                        {nm}
                                      </span>
                                    )}
                                    {curr.searched.includes(
                                      nm.toLowerCase(),
                                    ) && <span key={idx}>{nm}</span>}
                                  </>
                                ))}
                            </p>
                            <p className="a-f-content-search-header-text-footer">
                              {curr.currencyName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <button
            id="choose-currency-popup-button"
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                setShowAllCurrencies(false);
                setNewSearchContent(null);
                props.setPopupContentPosition("flex-end");
                props.setPopupContent(
                  <AddFunds
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    customLoading={props.customLoading}
                    setFavouriteClicked={props.setFavouriteClicked}
                    setCustomLoading={props.setCustomLoading}
                    generalDataProps={props.generalDataProps}
                    addFundsAction="add-funds-crypto"
                    accountBalance={selectedCurrency?.balance}
                    accountCurrency={selectedCurrency?.currencySymbol}
                    accountCurrencyAddress={selectedCurrency?.tokenAddress}
                    accountCurrencyDecimals={selectedCurrency?.tokenDecimals}
                    accountNumber={props.selectedCurrency?.currencySymbol}
                    accountAddress={props.selectedCurrency?.tokenAddress}
                  />,
                );
                props.setShowPopup(true);
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  setShowAllCurrencies(false);
                  setNewSearchContent(null);
                  props.setPopupContentPosition("flex-end");
                  props.setPopupContent(
                    <AddFunds
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      customLoading={props.customLoading}
                      setFavouriteClicked={props.setFavouriteClicked}
                      setCustomLoading={props.setCustomLoading}
                      generalDataProps={props.generalDataProps}
                      addFundsAction="add-funds-crypto"
                      accountBalance={selectedCurrency?.balance}
                      accountCurrency={selectedCurrency?.currencySymbol}
                      accountCurrencyAddress={selectedCurrency?.tokenAddress}
                      accountCurrencyDecimals={selectedCurrency?.tokenDecimals}
                      accountNumber={props.selectedCurrency?.currencySymbol}
                      accountAddress={props.selectedCurrency?.tokenAddress}
                    />,
                  );
                  props.setShowPopup(true);
                }
              }
            }}
            className="startup-button"
          >
            <p className="st-button-text">Proceed</p>
          </button>
        </React.Fragment>
      )}
    </div>
  );
};

export default PaymentMethods;
